// src/components/drawer/bottom-area/bottom-area.styled.ts
import styled from "@emotion/styled";

export const BottomAreaContainer = styled.div`
    border-top: 1px solid #2b2d33;
    padding-top: 12px;
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
`;

export const ActionsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ActionButton = styled.button`
    width: 268px;
    min-height: 44px;
    height: 44px;
    padding: 12px;
    border-radius: 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    user-select: none;
    outline: none;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    line-height: 140%;
    letter-spacing: 0;
    text-align: center;
    vertical-align: middle;
    color: #e9ecf5;

    @media (hover: hover) {
        &:hover {
            background: #2b2d33;
        }
    }

    &:focus-visible {
        background: #23252a;
        outline: none !important;
        box-shadow: none;
        border-radius: 8px;
    }

    &:active {
        background: #23252a;
        border-radius: 8px;
    }

    &[data-pressed='true'] {
        background: #23252a;
        border-radius: 8px;
    }

    &:disabled {
        opacity: 0.35;
        pointer-events: none;
        cursor: default;
    }
`;

export const LogoutButton = styled(ActionButton)`
    color: #b7bdcb;
`;

export const UserCard = styled.div`
    width: 100%;
    height: 56px;
    padding-top: 8px;
    padding-bottom: 0;
    border-top: 1px solid #2b2d33;

    display: flex;
    align-items: center;
    gap: 12px;
`;

/**
 * Avatar:
 * - If `src` exists -> background image
 * - Else -> Google-like initial bubble
 */
export const UserAvatar = styled.div<{ src?: string }>`
    width: 28px;
    height: 28px;
    border-radius: 999px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background: ${(
        { src },
    ) => (src ? `url(${src}) center/cover no-repeat` : "#2b2d33")};

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 1;
    color: #e9ecf5;

    box-shadow: 0 0 0 1px rgba(233, 236, 245, 0.06) inset;
`;

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const UserName = styled.div`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    line-height: 120%;
    letter-spacing: 0;
    text-align: left;
    vertical-align: middle;
    color: #e9ecf5;
`;

export const UserPlan = styled.div`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0;
    text-align: left;
    vertical-align: middle;
    color: #b7bdcb;
`;
